// config file

const config = {

    brandId: 'generic',                                                  // see common/branding.js for brandIds
    apiURL: process.env.REACT_APP_CI_API,                                 // cochlear api url
    imagePath: '/images/',                                                // folder where the images live
    defaultCountryCode: 'en',                                             // country code is normally taken from the url
    devMode: process.env.REACT_APP_DEV_MODE === 'true' ? true : false,    // set to true for development
    autoAnswer: false,                                                    // answer questions automatically with no wait, useful for development
    BUFFER_TIME: 1,         // how long to wait before playback starts
    STUDY_IDS: ["Insert Study ID here"],
    CALIBRATE_PURE_TONE_AUDIO_FILE: '/audio/pureTone.wav',
    CALIBRATE_WARBLE_TONE_AUDIO_FILE: '/audio/warbleTone.wav',
    REACT_APP_STUDY_IDS: process.env.REACT_APP_STUDY_IDS,
    PROXY_SERVER: '', //"https://cors-anywhere.herokuapp.com/",   // set this to "" turn not use proxy server
    AUTHORIZATION_TOKEN_TIMEOUT_HOURS: 1,
    //env: process.env.REACT_APP_MARKETO_ENV,  // SIT, UAT or PRD
    //LOGIN_COOKIE_TIMEOUT_HOURS: 24,

    getImage: (image) => {

      return config.imagePath + image
    }
  }

  export default config
